import ctl from "@netlify/classnames-template-literals";

export const item = ctl(`
  flex
  items-center
  cursor-pointer
  py-2
  px-3
  gap-4
  rounded-lg
  text-neutral-900
  hover:bg-neutral-50
  focus:bg-neutral-50
  active:bg-neutral-100
`);

export const itemDark = ctl(`
  ${item}
  hover:!bg-neutral-900
  focus:!bg-transparent
  active:!bg-purple-700
  !text-neutral-200
`);

export const itemSelected = ctl(`
  !bg-blue-50
  !text-blue-900
  hover:!bg-blue-100
  focus:!bg-blue-100
  active:!bg-blue-200
`);

export const itemSelectedDark = ctl(`
  !bg-purple-900
  !text-white
  hover:!bg-purple-700
  focus:!bg-purple-900
  active:!bg-purple-650
`);

export const dropdownButton = ctl(`
  flex
  gap-3
  rounded-xl
  bg-blue-50
  py-2
  px-4
  text-blue-900
`);

export const dropdownItems = ctl(`
  absolute
  top-0
  right-0
  z-20
  mt-1
  flex min-w-[16rem]
  flex-col
  gap-2
  rounded-lg
  bg-white
  p-2
`);

export const appBannerBorder = ctl(`
  p-0.5
  bg-white/5
  rounded-3xl
`);

export const appBanner = ctl(`
  flex
  flex-col
  items-start
  justify-center
  p-4
  bg-gradient-ellipse-br
  from-purple-500
  via-purple-800
  to-purple-950
  rounded-3xl
`);
